import { useState } from "react";

import { Formik, Form } from "formik";

import { useForgotPasswordMutation } from "@sso/apis/resetPassword";
import { AuthHeader } from "@sso/components/AuthHeader";
import { FormikTextInput } from "@sso/components/Formik/FormikTextInput";
import { SubmitLoadingButton } from "@sso/components/SubmitLoadingButton";
import { config } from "@sso/config";
import { AuthKeys, forgotPasswordInitialValues, notificationsMsgs, PathKeys } from "@sso/constant";
import { ForgotPasswordType } from "@sso/types";
import { CustomLink } from "@sso/ui/CustomLink";

import { ForgotPasswordCounter } from "./ForgotPasswordCounter";
import { forgotPasswordValidation } from "./schema";

export const ForgotPassword = () => {
  const [disableCounter, setDisableCounter] = useState<boolean>(false);

  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const handleOnSubmit = (values: ForgotPasswordType) => {
    forgotPassword({ ...values, successMessage: notificationsMsgs.FORGOT_PASSWORD })
      .unwrap()
      .then(() => setDisableCounter(true));
  };

  return (
    <>
      <AuthHeader
        title="Forgot Password?"
        description="Enter your user name/email below and we'll send you password reset link."
      />
      <Formik
        initialValues={forgotPasswordInitialValues}
        validationSchema={forgotPasswordValidation}
        onSubmit={handleOnSubmit}
      >
        <Form>
          <FormikTextInput name={AuthKeys.EMAIL} label="Email" />
          <SubmitLoadingButton
            loading={isLoading}
            disabledButton={disableCounter}
            buttonTitle={
              !isLoading && disableCounter ? (
                <ForgotPasswordCounter count={config.resetEmailCountdownValue} setDisableCounter={setDisableCounter} />
              ) : (
                "Send Email"
              )
            }
          />
        </Form>
      </Formik>
      <CustomLink to={PathKeys.SIGN_IN} margin="1.5rem 0 0.5rem 0" fontWeight={500}>
        Already have an account?
      </CustomLink>
    </>
  );
};
